import { put } from 'redux-saga/effects';
// import { reportsEndpoints } from '../../services/endpoints/reports.endpoints';
// import { InMemoryCache } from '../../shared/cache';
import ReportsActions from '../actions/reports.actions';

export function* getMTDYTDClientUncategorizedRequest(api, action) {
  const { clientId, timezoneOffset } = action;
  const response = yield api.getMTDYTDClientUncategorized(clientId, timezoneOffset);
  if (response && response.ok) {
    yield put(ReportsActions.getMTDYTDClientUncategorizedSuccess(response.data));
  } else {
    yield put(ReportsActions.getMTDYTDClientUncategorizedFailure());
  }
}

export function* getYTDClientStatsRequest(api, action) {
  const { clientId, timezoneOffset } = action;
  const response = yield api.getYTDClientStats(clientId, timezoneOffset);
  if (response && response.ok) {
    yield put(ReportsActions.getYTDClientStatsSuccess(response.data));
  } else {
    yield put(ReportsActions.getYTDClientStatsFailure());
  }
}

export function* getMTDPastYearsClientStatsRequest(api, action) {
  const { clientId, timezoneOffset, currentDay } = action;
  const response = yield api.getMTDPastYearsClientStats(clientId, timezoneOffset, currentDay);
  if (response && response.ok) {
    yield put(ReportsActions.getMTDPastYearsClientStatsSuccess(response.data));
  } else {
    yield put(ReportsActions.getMTDPastYearsClientStatsFailure());
  }
}

export function* getDailyEmployeesShiftRequest(api, action) {
  const { date, timezoneOffset } = action;
  const response = yield api.getDailyEmployeesShift(date, timezoneOffset);
  if (response && response.ok) {
    yield put(ReportsActions.getDailyEmployeesShiftSuccess(response.data));
  } else {
    yield put(ReportsActions.getDailyEmployeesShiftFailure());
  }
}

export function* getWeeklyEmployeesShiftRequest(api, action) {
  const { startDate, endDate, timezoneOffset } = action;
  const response = yield api.getWeeklyEmployeesShift(startDate, endDate, timezoneOffset);
  if (response && response.ok) {
    yield put(ReportsActions.getWeeklyEmployeesShiftSuccess(response.data));
  } else {
    yield put(ReportsActions.getWeeklyEmployeesShiftFailure());
  }
}
